import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e777b4a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_4 = { class: "ant-col ant-col-xs-18 ant-col-xl-18" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_7 = { class: "ant-col ant-col-xs-18 ant-col-xl-4" }
const _hoisted_8 = { class: "ant-col ant-col-xs-6 ant-col-xl-2" }
const _hoisted_9 = { class: "ant-col ant-col-xs-18 ant-col-xl-4" }
const _hoisted_10 = { class: "ant-col ant-col-xs-6 ant-col-xl-2" }
const _hoisted_11 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_14 = { class: "ant-col ant-col-xs-19 ant-col-xl-19" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-8"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Tipo de Documento"
}, "Tipo de Documento", -1))
const _hoisted_21 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-8"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Categoria"
}, "Categoria", -1))
const _hoisted_23 = {
  key: 0,
  class: "ant-col ant-col-xs-12 ant-col-xl-12 ss-pl-col"
}
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-14 ant-col-xl-14" }
const _hoisted_26 = {
  key: 0,
  class: "ant-col ant-col-xs-10 ant-col-xl-10"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Movimentações", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-10 ss-div-botao-duplo"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Movimentações", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "ant-btn ant-btn-primary ss-botao-duplo" }, "Fluxo de Caixa", -1))
const _hoisted_33 = { class: "ant-row" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_37 = { class: "ant-row" }
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_39 = { class: "ant-row" }
const _hoisted_40 = { class: "ant-col ant-col-xl-24 ant-col-xs-24" }
const _hoisted_41 = { class: "ant-row" }
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_conta = _resolveComponent("selecionar-tipo-conta")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_banco = _resolveComponent("selecionar-banco")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_configuracao_boletos_modal = _resolveComponent("configuracao-boletos-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1000,
    centered: "",
    "wrap-class-name": "ss-modal-cadastros"
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Cadastro de Contas "),
      _createVNode(_component_a_switch, {
        checked: _ctx.state.conta.ativo,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.conta.ativo) = $event)),
        style: {"float":"right"},
        "checked-children": "Ativa",
        "un-checked-children": "Inativa"
      }, null, 8, ["checked"])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir) || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_conta, {
                            valor: _ctx.state.conta.tipo,
                            "onUpdate:valor": [
                              _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.conta.tipo) = $event)),
                              _cache[4] || (_cache[4] = ($event: any) => (_ctx.validarTipoConta()))
                            ]
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_a_form_item, {
                        label: "Descrição",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tooltip, {
                            placement: "top",
                            title: "Cria uma descrição padronizada com os dados da agência e conta báncaria."
                          }, {
                            default: _withCtx(() => [
                              (_ctx.state.conta.tipo === _ctx.ETipoConta.ContaCorrente || _ctx.state.conta.tipo === _ctx.ETipoConta.ContaPoupanca)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "ss-apresentar-superior-direito ss-fonte-negrito ss-botao-acima-campo",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.preencherDescricaoDadosBancarios()))
                                  }, [
                                    _createVNode(_component_icone, { nome: "informacoes-fp" }),
                                    _createTextVNode(" Preencher com Dados Bancários")
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            maxlength: "250",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.conta.descricao) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.conta.descricao]
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              (_ctx.state.conta.tipo === _ctx.ETipoConta.ContaCorrente || _ctx.state.conta.tipo === _ctx.ETipoConta.ContaPoupanca)
                ? (_openBlock(), _createBlock(_component_card, {
                    key: 0,
                    titulo: "DADOS BANCÁRIOS"
                  }, {
                    AcoesExtra: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ss-fonte-negrito ss-card-botao-acao-extra",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.abrirConfiguracaoBoletos && _ctx.abrirConfiguracaoBoletos(...args)))
                      }, "Configurar Boleto")
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_selecionar_banco, {
                            codigoSelecionado: _ctx.state.conta.codigoBanco,
                            "onUpdate:codigoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.conta.codigoBanco) = $event)),
                            nomeSelecionado: _ctx.state.nomeBanco,
                            "onUpdate:nomeSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.nomeBanco) = $event)),
                            required: true
                          }, null, 8, ["codigoSelecionado", "nomeSelecionado"])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_a_form_item, {
                            label: "Agência",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "10",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.conta.contaBancaria.agencia) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.conta.contaBancaria.agencia]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_a_form_item, {
                            label: "Dígito",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "2",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.conta.contaBancaria.agenciaDv) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.conta.contaBancaria.agenciaDv]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_a_form_item, {
                            label: "Conta",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "15",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.conta.contaBancaria.conta) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.conta.contaBancaria.conta]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_a_form_item, {
                            label: "Dígito",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "2",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.conta.contaBancaria.contaDv) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.conta.contaBancaria.contaDv]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_a_form_item, {
                            label: "Convênio",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "50",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.conta.contaBancaria.convenio) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.conta.contaBancaria.convenio]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_a_form_item, {
                            label: "Conta da Empresa",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_sim_nao, {
                                radioButton: true,
                                valor: _ctx.state.conta.contaBancaria.contaEmpresa,
                                "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.conta.contaBancaria.contaEmpresa) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_a_form_item, {
                            label: "Proprietário",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_pessoa, {
                                codigoSelecionado: _ctx.state.conta.contaBancaria.codigoPessoa,
                                "onUpdate:codigoSelecionado": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.conta.contaBancaria.codigoPessoa) = $event)),
                                empresas: [_ctx.state.conta.codigoEmpresa],
                                recursoOrigem: _ctx.telaBase.identificadorRecurso
                              }, null, 8, ["codigoSelecionado", "empresas", "recursoOrigem"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_a_form_item, {
                    label: "Limite de Crédito",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_numerico, {
                        valor: _ctx.state.conta.limiteCredito,
                        "onUpdate:valor": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.conta.limiteCredito) = $event)),
                        monetario: true,
                        quantidadeCasasDecimais: 2
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.state.conta.codigo === 0?'ant-col ant-col-xs-24 ant-col-xl-24':'ant-col ant-col-xs-24 ant-col-xl-12 ss-pr-col')
                }, [
                  _createVNode(_component_card, { titulo: "SALDO INICIAL" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.state.conta.codigo === 0?'ant-col ant-col-xs-24 ant-col-xl-4':'ant-col ant-col-xs-24 ant-col-xl-10')
                        }, [
                          _createVNode(_component_a_form_item, {
                            label: "Data",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: _ctx.state.conta.saldoInicial.data,
                                "onUpdate:dataSelecionada": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.conta.saldoInicial.data) = $event)),
                                horaMinutoSegundo: true,
                                disabled: _ctx.props.operacao.tipoPermissaoDados !== _ctx.EPermissaoDados.Incluir && _ctx.UtilitarioData.validaDataPreenchida(_ctx.state.conta.saldoInicial.data) 
                              }, null, 8, ["dataSelecionada", "disabled"])
                            ]),
                            _: 1
                          })
                        ], 2),
                        ((_ctx.state.conta.codigo === 0))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                label: _withCtx(() => [
                                  _hoisted_20,
                                  _createVNode(_component_a_tooltip, {
                                    placement: "top",
                                    title: "Defina um tipo de documento para criar o movimento do Saldo Inicial da Conta."
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_icone, {
                                        class: "ss-icone-informacao-campo",
                                        nome: "informacao-campo"
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_tipo_documento_financeiro, {
                                    codigoSelecionado: _ctx.state.conta.saldoInicial.codigoTipoDocumentoFinanceiro,
                                    "onUpdate:codigoSelecionado": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.conta.saldoInicial.codigoTipoDocumentoFinanceiro) = $event)),
                                    empresas: [_ctx.state.conta.codigoEmpresa]
                                  }, null, 8, ["codigoSelecionado", "empresas"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        ((_ctx.state.conta.codigo === 0))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                label: _withCtx(() => [
                                  _hoisted_22,
                                  _createVNode(_component_a_tooltip, {
                                    placement: "top",
                                    title: "Defina uma categoria para criar o movimento do Saldo Inicial da Conta."
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_icone, {
                                        class: "ss-icone-informacao-campo",
                                        nome: "informacao-campo"
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_categoria_plano_conta, {
                                    codigoSelecionado: _ctx.state.conta.saldoInicial.codigoPlanoContaCategoria,
                                    "onUpdate:codigoSelecionado": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.conta.saldoInicial.codigoPlanoContaCategoria) = $event)),
                                    empresas: [_ctx.state.conta.codigoEmpresa],
                                    tipoPlanoConta: 1
                                  }, null, 8, ["codigoSelecionado", "empresas"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.state.conta.codigo === 0?'ant-col ant-col-xs-24 ant-col-xl-4':'ant-col ant-col-xs-24 ant-col-xl-14')
                        }, [
                          _createVNode(_component_a_form_item, {
                            label: "Saldo",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                valor: _ctx.state.conta.saldoInicial.saldo,
                                "onUpdate:valor": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.conta.saldoInicial.saldo) = $event)),
                                monetario: true,
                                quantidadeCasasDecimais: 2
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ], 2)
                      ])
                    ]),
                    _: 1
                  })
                ], 2),
                ((_ctx.state.conta.codigo > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_card, { titulo: "RESUMO" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_component_a_form_item, {
                                label: "Saldo Atual",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_campo_numerico, {
                                    valor: _ctx.state.saldoAtual,
                                    "onUpdate:valor": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.saldoAtual) = $event)),
                                    monetario: true,
                                    quantidadeCasasDecimais: 2,
                                    disabled: ""
                                  }, null, 8, ["valor"])
                                ]),
                                _: 1
                              })
                            ]),
                            (_ctx.state.conta.tipo === _ctx.ETipoConta.CaixaDiario)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _createVNode(_component_a_form_item, {
                                    label: " ",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        class: "ant-btn ant-btn-primary ss-botao-unico",
                                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.redirecionarMovimentos()))
                                      }, _hoisted_28)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createElementVNode("button", {
                                    class: "ant-btn ant-btn-primary ss-botao-duplo",
                                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.redirecionarMovimentos()))
                                  }, _hoisted_31),
                                  _hoisted_32
                                ]))
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_card, { titulo: "DEFINIÇÕES" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_a_checkbox, {
                        class: "ss-margin-campos",
                        checked: _ctx.state.conta.padrao,
                        "onUpdate:checked": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.conta.padrao) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Conta Padrão")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_a_checkbox, {
                        class: "ss-margin-campos",
                        checked: _ctx.state.conta.contasReceber,
                        "onUpdate:checked": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.conta.contasReceber) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Lançar Contas a Receber")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_a_checkbox, {
                        class: "ss-margin-campos",
                        checked: _ctx.state.conta.contasPagar,
                        "onUpdate:checked": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.conta.contasPagar) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Lançar Contas a Pagar")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_a_checkbox, {
                        class: "ss-margin-campos",
                        checked: _ctx.state.conta.influenciaFluxoFinanceiro,
                        "onUpdate:checked": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.conta.influenciaFluxoFinanceiro) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Influenciar Fluxo Financeiro")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                        label: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.state.conta.usuariosEspecificos,
                            "onUpdate:checked": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.conta.usuariosEspecificos) = $event)),
                            onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.limparUsuarios()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Especificar usuários que podem movimentar essa conta")
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ]),
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_selecionar_usuario, {
                            codigosSelecionados: _ctx.state.usuarios,
                            "onUpdate:codigosSelecionados": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.usuarios) = $event)),
                            varios: true,
                            empresas: [_ctx.state.conta.codigoEmpresa],
                            placeholder: ''
                          }, null, 8, ["codigosSelecionados", "empresas"]), [
                            [_vShow, _ctx.state.conta.usuariosEspecificos]
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_a_form_item, {
                        label: "Empresa",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_empresa, {
                            codigoSelecionado: _ctx.state.conta.codigoEmpresa,
                            "onUpdate:codigoSelecionado": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.conta.codigoEmpresa) = $event)),
                            empresasEspecificas: _ctx.telaBase.empresasDisponiveis
                          }, null, 8, ["codigoSelecionado", "empresasEspecificas"])
                        ]),
                        _: 1
                      })
                    ])
                  ], 512), [
                    [_vShow, _ctx.telaBase.apresentarEmpresas]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"]),
      (_ctx.state.conta.tipo === _ctx.ETipoConta.ContaCorrente || _ctx.state.conta.tipo === _ctx.ETipoConta.ContaPoupanca)
        ? (_openBlock(), _createBlock(_component_configuracao_boletos_modal, {
            key: 0,
            visivel: _ctx.state.exibirModalConfiguracaoBoletos,
            "onUpdate:visivel": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.exibirModalConfiguracaoBoletos) = $event)),
            configuracao: _ctx.state.conta.configuracaoBoletos,
            "onUpdate:configuracao": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.conta.configuracaoBoletos) = $event)),
            empresa: _ctx.state.conta.codigoEmpresa,
            banco: _ctx.state.conta.codigoBanco,
            onConfirmacao: _ctx.atualizarConfiguracaoBoletos
          }, null, 8, ["visivel", "configuracao", "empresa", "banco", "onConfirmacao"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}